export const GET_ENDPOINTS = 'ENDPOINTS/GET_ENDPOINTS';
export const GET_ENDPOINTS_PENDING = `${GET_ENDPOINTS}_PENDING`;
export const GET_ENDPOINTS_FULFILLED = `${GET_ENDPOINTS}_FULFILLED`;
export const GET_ENDPOINTS_REJECTED = `${GET_ENDPOINTS}_REJECTED`;

export const getEndpoints = () => ({
  type: GET_ENDPOINTS,
});
